import React from 'react';
import {
  SkillCard,
  Gallery,
  HorizontalLine,
  ProjectLayout,
  ProjectCard,
  Section,
  Title,
  Timeline,
} from '../components';
import { Hero, About, Contact } from './';
import { projectData, profileData } from '../data';
import Marquee from 'react-fast-marquee';

import './../index.css';

const Home = () => (
  <div className="items-start">
    <Hero />
    <HorizontalLine />

    {/* Marquee */}
    <Section className="hidden px-16 pt-5 pb-5 md:block" id="marquee">
      <div className="flex flex-row items-center justify-start gap-x-10">
        <h3 className="text-3xl font-medium text-primary w-fit whitespace-nowrap">
          Technical skills
        </h3>
        <Marquee speed="50" gradient gradientColor="var(--background)">
          <Gallery />
        </Marquee>
      </div>
    </Section>
    <HorizontalLine />

    <About />
    <HorizontalLine />
    
    <Section id="projects">
      <Title as="h2">Latest projects</Title>
      <ProjectLayout>
        <ProjectCard project={projectData.masterthesis} />
        <ProjectCard project={projectData.portfolio} />
        {/* 
        <ProjectCard project={projectData.bachelorthesis} />
        <ProjectCard project={projectData.knitrr} />
        */}
      </ProjectLayout>
      {/*
      <div className="flex justify-center mt-14 scroll-mt-">
        <ExternalLink title="View all my projects" href="/projects" />
      </div>
      */}
    </Section>
    <HorizontalLine />

    <Section id="skills">
      <Title as="h2">Languages & Tools</Title>
      <div className="mt-10 border divide-y shadow-sm divide-foreground-accent border-foreground rounded-3xl bg-foreground-light">
        <SkillCard field={profileData.stack.frontend} />
        <SkillCard field={profileData.stack.backend} />
        <SkillCard field={profileData.stack.cloud} />
        <SkillCard field={profileData.stack.database} />
        <SkillCard field={profileData.stack.data} />
        <SkillCard field={profileData.stack.tools} />
      </div>
    </Section>
    <HorizontalLine />

    <Section id="experience">
      <Title as="h2">Experience</Title>
      <div className="pt-3">
        <Timeline field="experience" />
      </div>
    </Section>
    <HorizontalLine />

    <Section className="pb-0" id="education">
      <Title as="h2">Education</Title>
      <div className="pt-3 mb-20">
        <Timeline field="education" />
      </div>
    </Section>
    <HorizontalLine />
    
    <Contact />
  </div>
);

export default Home;

/*
Section: Certifications 
<Section className='border-t'>
  <Title as="h2">Certifications</Title>
  <div className="flex justify-center pb-10">
    <img
      className="w-full overflow-hidden bg-gray-200 shadow-2xl rounded-3xl md:w-3/5 ring-1 ring-neutral-300"
      src={mastersdegree1}
      alt="My Graduation 2026"
    />
  </div>
</Section>

const Values = () => {
  return (
    <Section className="mb-10">
      <Title as="h2">Values</Title>
      <div className="">Intro Quote</div>
      <div className="flex flex-col justify-between my-3 gap-x-5 xl:flex-row">
        <div className="values-card">
          <Title as="h3">Clarity Over Complexity</Title>I believe code should be
          written to be read by humans first, and executed by machines second.
        </div>
        <div className="values-card">
          <Title as="h3">Full-Stack Ownership</Title>I like knowing how my
          frontend talks to my backend, and how that backend lives in the cloud.
          Having a holistic view makes me a better problem solver.
        </div>
        <div className="values-card">
          <Title as="h3">Continuous Iteration</Title>
          The best software isn&#39;t built overnight; it&#39;s grown through
          continuous feedback, refactoring, and steady improvement.
        </div>
      </div>
    </Section>
  );
};

import { ImageStack }
const Interests = () => {
  return (
    <Section>
      <Title as="h2">Interests</Title>

      <div className="flex flex-col gap-12 md:flex-row md:gap-0">
        <div className="flex flex-col w-full gap-7 md:w-2/3">
          <div>Always loved Learning and mastering</div>

          <div className='flex flex-row justify-start md:flex-col gap-y-5'>
            <div className='w-1/2 md:w-full'>
              <Title as="h4">Sports</Title>
              <ul className="list-disc list-inside">
                <li>Basketball</li>
                <li>Volleyball</li>
                <li>Football</li>
              </ul>
            </div>
            <div className='w-1/2 md:w-full'>
              <Title as="h4">Creative interests</Title>
              <ul className="list-disc list-inside">
                <li>Photography</li>
                <li>Cinematography</li>
                <li>Culinary arts</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/3">
          <ImageStack />
        </div>
      </div>
    </Section>
  );
};
*/
